import { useCallback } from "react";
import { getItemVersionPair, type ItemVersionPair } from "../../../api/content/itemsApi";
import { useLoad, type LoadHandle } from "../../../shared/loading/useLoad";

/** The versions before and after an item change, loaded together and read again on retry. */
export function useItemVersionPair(change: { readonly oldReference: string | null; readonly newReference: string | null }): LoadHandle<ItemVersionPair> {
  const { oldReference, newReference } = change;
  const load = useCallback((signal: AbortSignal) => getItemVersionPair(oldReference, newReference, signal), [oldReference, newReference]);
  return useLoad(load);
}
